//import { useParams } from 'react-router-dom';
import { all } from '../data/all';

function Continents() {
    //const { Continents } = useParams();

    let continentData = [];
    
    all.forEach(thisCountry => {
            continentData = [...continentData, thisCountry.region];
    })

    continentData.sort();

    let uniqueContinents = [...new Set(continentData)];

    return (
        <code>
            { JSON.stringify(uniqueContinents) }
        </code>
    )
}

export default Continents;